import type { FaireProductEntity } from "../../entity_types/product";

export const p_guqb5mekua: FaireProductEntity = {
  token: "p_guqb5mekua",
  type: "product",
  name: "Thank You No. 09",
  brandToken: "b_umfa9a7xcn",
  brandName: "Jaymes Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8db26573bb0d61fb8434ce35880b5e12b0207149eb47a74c73727e8d7ddf778b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9359ec8d2beec8da172f5dd7d112ef3d145670a0960d7f6c1ad8dfaccfb42a22.jpeg",
    "https://cdn.faire.com/fastly/522c126aaa47e49bf31d3be52dde6d946fe26457dccffcd240b337d5c1ee3c48.jpeg",
    "https://cdn.faire.com/fastly/cee137a29b3853b2df78d832ab1e77752ceabca8020334884db8a2359281b6f3.jpeg",
    "https://cdn.faire.com/fastly/a330e17544643f1b1e398dd215705ad946fdaf03dd41f28c006223f5c4ae2dcd.jpeg",
    "https://cdn.faire.com/fastly/5e89a69f424c94c783ef0d323caa835fceb0589b51c933112d2b487dd51acdae.jpeg",
  ],
  priceDollars: 3.75,
  description:
    '\n * A2 Folded 4.25" L × 5.5" W \n * "Thank You" \n * Creme Cover Stock \n * Letterpress \n * Natural Envelope \n * Blank interior \n * Made in Santa Barbara ',
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:29.672Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
